<template>
   <ct-modal
    v-if="visible"
    width="480px"
    title=""
    class="note-modal"
    @closed="closedModal"
  >
    <div slot="body" class="awards-body">
        <div class="img-title">
          <img width="148" src="@/assets/img/comet/course/gou@2x.png" alt="">
        </div>
        <h4 class="title">Congratulations</h4>
        <div class="text-center">
        <p>Knowledge debris collected successfully!</p>
          <span class="icons"><ct-icon :multiColor="true" name="proton"></ct-icon>PROTONS <span class="count">+{{proton}}</span></span>
          <span class="icons"><ct-icon :multiColor="true" name="neutron"></ct-icon>NEUTRONS <span class="cpunt">+{{neutron}}</span></span>
        </div>
    </div>
    <div slot="footer" class="text-center">
        <ct-button
        type="primary"
        @click="closedModal"
        >Got it！</ct-button>
    </div>
  </ct-modal>
</template>
<script>
export default {
  name: 'Awards',
  props: {
    awards: Object,
    closeCallback: Function
  },
  computed: {
    proton () {
      return this.awards.proton
    },
    neutron () {
      return this.awards.neutron
    }
  },
  data () {
    return {
      visible: true
    }
  },
  methods: {
    shownoteModal () {
      this.visible = true
    },
    closedModal () {
      this.visible = false
      this.closeCallback()
    }
  },
  mounted () {
  }
}
</script>
<style scoped lang="scss">
@import '@/styles/_varaible.scss';

$textColor: #A3B1BF;
.note-modal {
  z-index: 2000;
  .img-title{
    text-align: center;
    margin-bottom: 24px;
  }
  .title{
    margin-bottom: 24px;
    text-align: center;
  }
  .action-btn{
    margin: 8px 16px 0;
  }
  .icons{
      display: inline-block;
      vertical-align: middle;
      margin-top: 30px;
    margin-bottom: 30px;
      .ct-icon{
        font-size: 18px;
        margin-right: 8px;
      }
      .count{
        font-family:SFProDisplay-Medium;
font-weight:500;
      }
  }
  .icons + .icons{
    margin-left: 24px;
  }
}

</style>
